export const validateFileType = (file, arrayOfAllowedFileTypes) => {
  if (!arrayOfAllowedFileTypes.includes(file.type)) {
    return false
  }

  return true
}
